// 股票信息
<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img :src="image" class="bg"></div>

    <div style="margin-top:4.6875rem">
        <div class="select" v-for="(list,i) in lists">
        <div class="layout">
            <img class="img" src="../../assets/Investor/select.png">
            <router-link :to="list.path" class="link">
                <div class="text">{{list.title}}</div>
            </router-link>
        </div>
    </div>
    </div>
    <Tabbar class="tabbar"></Tabbar>
    
  </div>
</template>

<script>
import Tabbar from '../Index/Index_components/Tabbar.vue'
import Logo from "../Index/Index_components/logo.vue"
// import Header from '../../common/FirstHeader.vue'
import api from '@/utils/api'
export default {
  name: 'Shares',
  components: {
    Tabbar,
    // Header,
    Logo,
  },
  created () {
    if (window.localStorage.getItem('investor')) {
      var image1 = JSON.parse(window.localStorage.getItem('investor'))
      this.image = image1.data.data.image
    }
  },
  data () {
    return {
      lists: [
        { id: 1, title: '基础信息', path: '/investor/shares/basic' },
        { id: 2, title: '市场信息', path: '/investor/shares/market' },
        // { id: 3, title: '十大股东', path: '/investor/shares/tenInvestors' }
      ],
      image: '',
    }
  },
}
</script>

<style scoped>
.bg {
  width: 46.875rem;
  height: 14.75rem;
}
.tabbar {
  margin-top: 44.125rem;
}
.select {
  width: 42.5rem;
  height: 2.125rem;
  margin-bottom: 3.5rem;
}
/* 蓝色小方块 */
.img {
  width: 0.875rem;
  height: 1.75rem;
  margin-left: 2.375rem;
  margin-top: auto;
  margin-bottom: auto;
}
.layout {
  display: flex;
}
/* 文字 */
.text {
  margin-left: 1rem;
  font-size: 1.875rem;
  color: #333333;
}
.link {
  text-decoration: none;
}
</style>